export enum BUCode {
  NTD = 'NTD',
  EGL = 'EGL',
  ECD = 'ECD',
  TGI = 'TGI'
}
